import { render, staticRenderFns } from "./RecentNews.vue?vue&type=template&id=9e393c2a&scoped=true"
import script from "./RecentNews.vue?vue&type=script&lang=js"
export * from "./RecentNews.vue?vue&type=script&lang=js"
import style0 from "./RecentNews.vue?vue&type=style&index=0&id=9e393c2a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e393c2a",
  null
  
)

export default component.exports